import React from "react";
import MarketingBanner from "../marketing/MarketingBanner";
import MarketingBox from "../marketing/MarketingBox";
import Popup from "reactjs-popup";

import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";
import ImagesPopup from "../components/ImagesPopup";

export default function OfferImage(props) {
  const { offer, hotels, imgurl, imgCount, pictIdx, setPictIdx } = props;
  const [popupOpen, setPopupOpen] = React.useState(false);

  return (
    <div
      className="offerimage"
      style={{
        marginRight: 16,
        border: "1px black solid",
        display: "flex",
        flexDirection: "column",
        backgroundImage:
          "url(" +
          (imgurl
            ? imgurl
            : hotels.Hotel.find(
                (e) =>
                  e.HotelID ===
                  offer.OfferServices.Package.Accommodation.HotelRef.HotelID
              ).HotelImages.LargeImage) +
          ")",
      }}
    >
      <Popup
        closeOnDocumentClick={false}
        open={popupOpen}
        position="center"
        modal
        overlayStyle={{ zIndex: 10000 }}
        onClose={() => {
          setPopupOpen(false);
        }}
      >
        <ImagesPopup
          hotel={
            hotels.Hotel.find(
              (e) =>
                e.HotelID === offer.OfferServices.Package.Accommodation.HotelRef.HotelID
            )
          }
          offer={offer}
          setPopupOpen={(val) => setPopupOpen(val)}
        />
      </Popup>

      <MarketingBanner className="offerbanner" offer={offer} onImage={true} />

      <div style={{ display: "flex", flexGrow: 1, flexDirection: "column" }}>
        <div
          style={{ flexGrow: 1, cursor: "pointer" }}
          onClick={() => setPopupOpen(true)}
        ></div>
        <div style={{ display: "flex" }}>
          <div>
            {pictIdx > 0 && (
              <span onClick={() => setPictIdx(pictIdx - 1)}>
                &nbsp;
                <FaChevronCircleLeft
                  size={40}
                  style={{ cursor: "pointer", color: "rgba(255,255,255,0.75)" }}
                />
              </span>
            )}
          </div>

          <div
            style={{ flexGrow: 1, cursor: "pointer" }}
            onClick={() => setPopupOpen(true)}
          ></div>
          <div>
            {pictIdx < imgCount - 1 && (
              <span onClick={() => setPictIdx(pictIdx + 1)}>
                <FaChevronCircleRight
                  size={40}
                  style={{ cursor: "pointer", color: "rgba(255,255,255,0.75)" }}
                />
                &nbsp;
              </span>
            )}
          </div>
        </div>
        <div
          style={{ flexGrow: 1, cursor: "pointer" }}
          onClick={() => setPopupOpen(true)}
        ></div>
      </div>
      <MarketingBox offer={offer} onpage="0021-0004" />
    </div>
  );
}


